import { assign, clone } from "lodash";
import { useSettlementStore } from "../store";
import {
  splitCell,
  mergeCells,
  insertRow,
  insertCol,
  deleteCols,
  deleteRows,
  getCellsBySelection,
  generateSelection,
} from "../utils";
import { Cell, TableEditorConfig } from "../dto";

// 表格增删改操作
const useOperate = () => {
  const [{ config, selection, mode }, { setConfig, setSelection }] =
    useSettlementStore();
  const { cellIds: selectedCellIds } = selection;
  // 重置选区
  const resetSelection = (newConfig: TableEditorConfig) => {
    if (selection.rect) {
      setSelection(
        generateSelection(
          newConfig,
          selection.rect.startId,
          selection.rect.endId
        )
      );
    }
  };
  return {
    splitCell: () => {
      if (mode !== "single") return;
      const { config: newConfig, cellIds } = splitCell(
        config,
        selectedCellIds[0]
      );
      setConfig(newConfig);
      setSelection((s) => {
        s.cellIds.push(...cellIds);
        s.rect.startId = selectedCellIds[0];
        s.rect.endId = cellIds[cellIds.length - 1];
      });
    },
    mergeCell: () => {
      if (mode !== "multiple") return;
      const { config: newConfig, mergeId } = mergeCells(config, selection.rect);
      setConfig(newConfig);
      setSelection((s) => {
        s.cellIds = [mergeId];
        s.rect.startId = mergeId;
        s.rect.endId = mergeId;
      });
    },
    insertRow: (direction: "before" | "after") => {
      if (mode !== "single") return;
      const newConfig = insertRow(config, selectedCellIds[0], direction);
      setConfig(newConfig);
      resetSelection(newConfig);
    },
    insertCol: (direction: "before" | "after") => {
      if (mode !== "single") return;
      const newConfig = insertCol(config, selectedCellIds[0], direction);
      setConfig(newConfig);
      resetSelection(newConfig);
    },
    deleteCols: () => {
      if (mode === "none") return;
      setConfig(deleteCols(config, selectedCellIds));
      setSelection({ cellIds: [] });
    },
    deleteRows: () => {
      if (mode === "none") return;
      setConfig(deleteRows(config, selectedCellIds));
      setSelection({ cellIds: [] });
    },
    setSelectionConfig: (selectionConfig: Partial<Cell>) => {
      const keys = Object.keys(selectionConfig);
      setConfig((cfg) => {
        const cells = getCellsBySelection(cfg, selection);
        cells.forEach(({ rowIndex, colIndex }) => {
          keys.forEach((key) => {
            const v = selectionConfig[key];
            const origin = cfg.rows[rowIndex].cells[colIndex][key];
            if (["style", "attr"].includes(key) && origin && v) {
              assign(cfg.rows[rowIndex].cells[colIndex][key], v);
            } else {
              cfg.rows[rowIndex].cells[colIndex][key] = v;
            }
          });
        });
      });
    },
    getSelectionConfig: () => {
      if (mode === "single") {
        return clone(getCellsBySelection(config, selection)[0]?.cell ?? {});
      }
      return {};
    },
  };
};

export default useOperate;
